import {
    addBulkEditId,
    getSelectionRange,
    removeBulkEditId,
    useBulkEditPosition,
} from '@/components/grid/bulk-edit-state'
import { GridContext } from '@/components/grid/grid'
import { getIsDeleted, useEditedGif } from '@/context/edit-manager'
import { NexaBlack } from '@/styles/fonts'
import { cn } from '@/util/cn'
import { AttributionOverlay, GifOverlayProps } from '@giphy/react-components'
import { useContext } from 'react'
import { useKeyPress } from 'react-use'

type Props = {
    count?: number
}

const BulkSelectorOverlay = ({ count = 0 }: GifOverlayProps & Props) => {
    return count > 0 ? (
        <div
            className={cn(
                `border-giphyIndigo absolute inset-0 box-border border-[6px] border-solid ${NexaBlack.className}`
            )}
        >
            {count && (
                <div className="bg-giphyYellow absolute right-[-6px] top-[-6px] flex size-9 items-center justify-center text-lg font-extrabold text-black">
                    {count}
                </div>
            )}
        </div>
    ) : null
}

export const BulkEditOverlay = ({ gif }: GifOverlayProps) => {
    const { position } = useBulkEditPosition(gif.id)
    const editedGif = useEditedGif(gif.id)
    const isDeleted = getIsDeleted(editedGif)
    const { gifs } = useContext(GridContext)
    const [isAlt] = useKeyPress('Alt')
    if (isDeleted) {
        return (
            <div
                className={`bg-giphyBlack/60 absolute inset-0 flex items-center justify-center text-2xl text-white ${NexaBlack.className}`}
            >
                DELETED
            </div>
        )
    }
    return isAlt ? (
        <>
            <div className="absolute inset-0 grid place-items-center">
                <div className="drop-shadow-text-shadow text-3xl font-bold uppercase">{gif.rating}</div>
            </div>
            <AttributionOverlay gif={gif} isHovered />
        </>
    ) : position > 0 ? (
        <div
            onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                removeBulkEditId(gif.id)
            }}
            className={cn(
                `border-giphyIndigo absolute inset-0 box-border border-[6px] border-solid ${NexaBlack.className}`
            )}
        >
            {position && (
                <div className="bg-giphyYellow absolute right-[-6px] top-[-6px] flex size-9 items-center justify-center text-lg font-extrabold text-black">
                    {position}
                </div>
            )}
        </div>
    ) : (
        <div
            className="absolute inset-0 cursor-pointer"
            onClick={async (e) => {
                e.preventDefault()
                e.stopPropagation()
                const gridIndex = gifs.findIndex((g) => g.id === gif.id)
                if (e.shiftKey) {
                    const [start, end] = getSelectionRange(gridIndex)
                    for (let i = start; i <= end; i++) {
                        const addGif = gifs[i]
                        addBulkEditId(addGif, i)
                    }
                } else {
                    addBulkEditId(gif, gridIndex)
                }
            }}
        ></div>
    )
}

export default BulkSelectorOverlay
